/* eslint-disable valid-typeof */
import React, { Component } from 'react';
import { isClient } from 'frontend/helpers/ssr-helper';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Helmet from 'react-helmet';
import moment from 'moment';
import { getNavigation, addCityEncapsulated } from '../../redux/actions/application-actions';
import { savePackageDetails } from '../../redux/actions/packages-actions';
import paquetesClient from '../../api/paquetes';
import Preloader from '../layout/Preloader';
import Commons from '../../commons/commons';
import DetalleRouter from './detalle-router';
import NoDisponible from '../layout/error-paquete/no-disponible';
import { Url } from '../../api/http-client';
import BreadCrumb from '../paquetes-lista/breadcrumb-lista';
import './paquetes-detalle.css';

const getParams = () => {
  if (!global.expressLocation && typeof 'window' === undefined) {
    return {
      origin: '',
      destination: '',
      month: '',
      distribution: '',
      since: '',
      until: '',
    };
  }
  const { pathname, search, host } = Commons.getLocationInformation();
  const urlObj = Url(`https://${host}${pathname}${search}`);
  const parts = pathname.replace('/packages/details/', '').split('/');
  return {
    url: `https://${host}${pathname}${search}`,
    origin: urlObj.searchParams.get('origen'),
    destination: urlObj.searchParams.get('d'),
    date: urlObj.searchParams.get('s'),
    title: parts[0],
  };
};

class PaqueteDetalle extends Component {
  static armarUrl() {
    const urlString = isClient ? window.location.href : '';
    return new URL(urlString);
  }

  constructor(props) {
    super(props);
    this.state = {
      paquete: {},
      preloader: true,
      error: false,
      cantPasajeros: 1,
    };
    this.getDetalle = this.getDetalle.bind(this);
    this.armarDatos = this.armarDatos.bind(this);
    this.ordenarSalidasPorPrecio = this.ordenarSalidasPorPrecio.bind(this);
    this.ordenarSalidasPorPrecio();
    this.setPreloader = this.setPreloader.bind(this);
  }

  componentDidMount() {
    this.props.actions.getNavigation();
    this.getDetalle();
  }

  getDetalle() {
    const distribucion = Commons.obtenerDistribucion();
    const cantPasajeros = Commons.obtenerCantidadPasajeros(distribucion);
    const data = this.armarDatos();

    paquetesClient
      .obtenerDetalle(data)
      .then((res) => {
        if (res.data.disponible && res.data.salidas.length > 0) {
          // saving package details on store
          this.props.actions.savePackageDetails({
            isReady: true,
            paxQuantity: cantPasajeros,
            data: res.data,
          });
          this.setState({
            cantPasajeros,
            paquete: res.data,
            preloader: false,
          });
        } else {
          this.setState({
            error: true,
            preloader: false,
          });
        }
      })
      .catch(() => {
        this.setState({
          error: true,
          preloader: false,
        });
      });
  }

  armarDatos() {
    const url = PaqueteDetalle.armarUrl();
    const idProveedor = this.props.location.proveedorId
      ? this.props.location.proveedorId
      : url.searchParams.get('p');
    return {
      idProveedor,
      IdSalida: url.searchParams.get('t'),
      fechaSalida: url.searchParams.get('s'),
      distribucion: url.searchParams.get('h'),
      tipoMoneda: url.searchParams.get('m'),
      idProducto: url.searchParams.get('i'),
      idDestino: url.searchParams.get('d'),
      nroGrupo: url.searchParams.get('ngrupo'),
      nroComb: url.searchParams.get('nroComb'),
    };
  }

  setPreloader(status) {
    this.setState({
      preloader: status,
    });
  }

  ordenarSalidasPorPrecio() {
    if (this.props.location.query) {
      this.props.location.query.sort((a, b) => a.precios.precioNeto - b.precios.precioNeto);
    }
  }

  createSeoElements() {
    const params = getParams();
    const { nombre, cities } = this.props.application;

    let tituloPaquete = Commons.filterText(params.title);
    tituloPaquete = tituloPaquete.charAt(0).toUpperCase() + tituloPaquete.slice(1);

    const destino = cities.filter((city) => params.destination === city.code)[0] || { name: params.destination };
    const origen = cities.filter((city) => params.origin === city.code)[0] || { name: params.origin };

    const month = moment(params.date, 'YYYY-MM-DD').format('MMMM');
    const mes = month.charAt(0).toUpperCase() + month.slice(1);

    const title = `${tituloPaquete} saliendo desde ${origen.name} - salida ${mes} | ${nombre}`;
    const description = `${tituloPaquete} saliendo desde ${origen.name} - salida ${mes}, viaja a ${destino.name} con ${nombre}`;

    const tituloParrafo = `${tituloPaquete} saliendo desde ${origen.name} - salida ${mes}, viaja a ${destino.name}`;
    const parrafo = `No te pierdas ${tituloPaquete}, disfruta viajar con nosotros a ${destino.name} con todo asesoramiento de los expertos de ${nombre}, encontrá la mejor atención y asesoramiento, ideas de viaje en ${nombre}. Somos la mejor opción para tus
      vacaciones, en ${nombre} contamos con los mejores precios para tu viaje a ${destino.name}, no te pierdas las ofertas y opciones que ${nombre} tiene para vos. ¡Reservá ya mismo tu lugar en ${tituloPaquete}!`;
    const h1 = `${tituloPaquete} saliendo desde ${origen.name} - salida ${mes}, viaja a ${destino.name}`;
    return {
      helmet: (
        <Helmet>
          <title>{ title }</title>
          <meta name='description' content={description} />
          <meta property='og:title' content={title} />
          <meta property='og:description' content={description} />
          <meta property='og:url' content={params.url} />
        </Helmet>
      ),
      paragraph: (
        <div className='container'>
          <div className='paragraph-seo-container text-sm text-gray-600'>
            <h2 className='font-color-mbr-color-primario mb-4'>{ tituloParrafo }</h2>
            <p>{ parrafo }</p>
          </div>
        </div>
      ),
      h1: <h1 className='s-h1 py-4'>{ h1 }</h1>,
    };
  }

  render() {
    const { helmet, paragraph, h1 } = this.createSeoElements();
    const { paquete, error, preloader, cantPasajeros } = this.state;
    const month = (paquete.salidas && paquete.salidas[0].fechaSalida && moment(paquete.salidas[0].fechaSalida).format('MMMM')) || '';

    return (
      <React.Fragment>
        { helmet }
        <BreadCrumb
          origin={paquete.salidas ? paquete.salidas[0].origenIata.split(';')[0] : null}
          destination={paquete.salidas ? paquete.salidas[0].destinoIata.split(';')[0] : null}
          searchMonth={month}
        />
        <div className='container'>{ h1 }</div>
        {error && <NoDisponible />}
        {preloader && (
          <Preloader
            titulo='Preparando el detalle de su paquete...'
          />
        )}
        {!preloader && paquete.disponible !== undefined && (
          <DetalleRouter
            proveedorId={PaqueteDetalle.armarUrl().searchParams.get('p')}
            distribucion={PaqueteDetalle.armarUrl().searchParams.get('h')}
            referencia={PaqueteDetalle.armarUrl().searchParams.get('t')}
            salidaNoVisible={this.props.location.indice}
            salidas={this.props.location.query}
            paquete={paquete}
            cantidadPasajeros={cantPasajeros}
            setPreloader={this.setPreloader}
          />
        )}
        { paragraph }
        <hr style={{ borderColor: '#d2d2d2', margin: '25px 0 0 0' }} />
      </React.Fragment>
    );
  }
}

const cityOrigin = () => (dispatch) => {
  const params = getParams();
  return addCityEncapsulated(params.origin, dispatch);
};

const cityDestination = () => (dispatch) => {
  const params = getParams();
  return addCityEncapsulated(params.destination, dispatch);
};

PaqueteDetalle.serverFetch = [cityOrigin, cityDestination];

const mapStateToProps = (store) => ({
  actualModule: store.applicationState.navigation.actualModule,
  application: store.applicationState,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ getNavigation, addCityEncapsulated, savePackageDetails }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaqueteDetalle);
